<template>
    <div id="registerPage">
        <div data-html2canvas-ignore="true" v-show="loader">
            <Loader />
            <!-- <div class="spinner-border" role="status">
        <span class="sr-only">Loading...</span>
      </div> -->
        </div>
        <!-- <div class="weavrLogoContainer">
      <img src="img/brand/weavr.svg" height="100%" alt="Brand Logo Full" />
    </div> -->
        <div class="container-fluid d-flex align-items-center">
            <LanguageSelect />
            <b-row class="hero-login-section d-flex align-items-center">
                <b-col md="7" class="left-img fullBgImg">
                    <div class="login-page-slider">
                        <div class="slider-container">
                            <div v-for="(slide, index) in slides" :key="index"
                                :class="['slide-wrapper', { active: currentSlide === index }]">
                                <div class="slideImgContainer" style="padding-bottom: 0px !important">
                                    <img :src="slide.image" class="img-fluid slide-image" :alt="slide.title" />
                                </div>
                                <div class="slide-content">
                                    <h2>{{ translatedLang[slide.title][selectedLanguage.key] }}</h2>
                                    <p>{{ translatedLang[slide.description][selectedLanguage.key] }}</p>
                                </div>
                            </div>
                            <div class="slider-controls">
                                <div class="slider-dots">
                                    <span v-for="(slide, index) in slides" :key="index"
                                        :class="['dot', { active: currentSlide === index }]" @click="goToSlide(index)">
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="brand-slider">
                        <swiper :options="swiperOptions">
                            <swiper-slide v-for="slide in sliderImages" :key="slide.id" class="brand-slide">
                                <img :src="slide.image" :alt="slide.altDec" class="brand-logo" />
                            </swiper-slide>
                        </swiper>
                    </div>
                </b-col>
                <b-col md="5">
                    <div class="weavrLogoContainer">
                        <div style="height: 40px">
                            <img src="Icons_SVG/weavr-login-img.svg" height="100%" alt="Brand Logo Full" />
                        </div>
                    </div>
                    <div class="form-container">
                        <h2 class="mainHeading mt-4 mb-0">{{ translatedLang["Forgot Password?"][selectedLanguage.key] }}</h2>
                        <template >
                            <p class="subHeading mb-0">
                                {{ translatedLang["Don’t worry! Resetting your password is easy. Just type in the email address you used to register for Weavr."][selectedLanguage.key] }}</p>
                            <div class="input-group"> 
                                <label for="email">{{ translatedLang["Email"][selectedLanguage.key] }}</label>
                                <div class="position-relative input-with-icon">
                                    <div class="position-absolute inputIconContainer tw-mt-1">
                                        <img src="Icons_SVG/emailWeavr.svg" height="100%" alt="email icon" />
                                    </div>
                                    <input id="email" type="email" required v-model="email"
                                        :placeholder='`${translatedLang["Enter your email address"][selectedLanguage.key]}`' />
                                </div>
                            </div>
                            <div  v-if="isEmailSent">
                                <p class="tw-my-4 tw-text-black tw-text-base">
                                    An email containing instructions to reset password has been sent.
                                </p>
                                <p class="tw-mb-8 tw-text-[#505050] tw-text-base">
                                    Didn’t receive the email? <span @click="checkEmail" class="tw-cursor-pointer tw-ml-1 tw-text-primary_brand tw-border-b-[1px] tw-border-[#065559]">Click to resend</span>
                                </p>
                            </div>
                            <button type="button" class="primarycolor w-100 mb-3" style="border-radius: 32px !important"
                                @click="handleSubmitButton">
                                {{ isEmailSent?translatedLang["Back to sign in"][selectedLanguage.key]:translatedLang["Send Reset Link"][selectedLanguage.key] }}
                            </button>
                        </template>
                    </div>
                </b-col>
            </b-row>
        </div>
    </div>
</template>

<script>
import countryCodes from "../../json/countryCodes.json";
import Loader from "../Components/Loader.vue";
import { Swiper, SwiperSlide } from "vue-awesome-swiper";
import LanguageSelect from "../Components/LanguageSelect.vue";
import { mapState, mapActions } from "vuex";
import "swiper/css/swiper.css";
export default {
    name: "Register",
    components: {
        Loader,
        Swiper,
        SwiperSlide,
        LanguageSelect
    },
    data() {
        return {
            loader: false,
            userVerified: false,
            firstName: "",
            lastName: "",
            email: "",
            companyName: "",
            brandNames: "",
            phoneNumber: "",
            password: "",
            showPassword: false,
            confPassword: "",
            showConfPassword: false,
            termsAndCondition: false,
            isEmailSent: false,
            slides: [
                {
                    image: "Icons_SVG/LqsImgLogin.svg",
                    title: "Magnify your eCommerce Presence with Weavr",
                    description: "Analyse multilingual customer reviews to pinpoint key factors influencing ratings and drive product improvements",
                },
                // {
                //   image: "Icons_SVG/pincodeLoginLeftImg.svg",
                //   title: "Pin code-level Availability Tracking",
                //   description:
                //     "Check stock availability with pin code-level tracking, optimizing your location-based inventory systems",
                // },
                {
                    image: 'Icons_SVG/dataInsightsLoginImg.svg',
                    title: 'Unified Marketing Data Insights',
                    description: 'Integrate 50+ marketing channels in a single dashboard. Get in-depth campaign insights to supplement your marketing efforts and boost e-commerce business efficiency.'
                }
            ],
            currentSlide: 0,
            sliderImages: [
                {
                    id: 1,
                    altDec: "Meta icon",
                    image: "Icons_SVG/metaLoginImgNew.svg",
                },
                {
                    id: 2,
                    altDec: "Google Analytics Icon",
                    image: "Icons_SVG/GaLoginImgNew.svg",
                },
                {
                    id: 3,
                    altDec: "Twitter Icon",
                    image: "Icons_SVG/twitterLoginImgNew.svg",
                },
                {
                    id: 4,
                    altDec: "Snapchat Icon",
                    image: "Icons_SVG/snapchatLoginImg.svg",
                },
                {
                    id: 5,
                    altDec: "indiagate",
                    image: "Icons_SVG/shopifyLoginImg.svg",
                },
            ],
            swiperOptions: {
                slidesPerView: 5,
                spaceBetween: 0,
                loop: true,
                autoplay: {
                    delay: 0,
                    disableOnInteraction: false,
                },
                speed: 900,
            },
            countryCodes: null,
            selectedCountry: {
                name: "India",
                code: "IN",
                emoji: "🇮🇳",
                unicode: "U+1F1EE U+1F1F3",
                image: "IN.svg",
                dial_code: "+91",
            },
            showRegionDropdown: false,
            countrySearchQuery: "",
            passwordRequirements: [
                {
                    msg: "Have at least a number",
                    color: "",
                    id: 1,
                    criteria: /\d/,
                    valid: false,
                },
                {
                    msg: "Have at least one lowercase letter",
                    color: "",
                    id: 2,
                    criteria: /[a-z]/,
                    valid: false,
                },
                {
                    msg: "Have at least one uppercase letter",
                    color: "",
                    id: 3,
                    criteria: /[A-Z]/,
                    valid: false,
                },
                {
                    msg: "Have at least one special character",
                    color: "",
                    id: 4,
                    criteria: /[!@#$%^&*(),.?":{}|<>]/,
                    valid: false,
                },
                {
                    msg: "Have at least one special character",
                    color: "",
                    id: 5,
                    criteria: /^.{8,}$/,
                    valid: false,
                },
            ],
            registerValidation: {
                // email: {
                //   flag: "invalid",
                //   msg: ""
                // },
                // companyName: {

                // }
                confirmPassword: {
                    color: "",
                    msg: "",
                    valid: false,
                },
            },
        };
    },
    computed: {
        ...mapState("DemoStore", ["selectedLanguage", "translatedLang"]),
    },
    created() {
        this.countryCodes = countryCodes.sort((a, b) => {
            const nameA = a.name.toLowerCase();
            const nameB = b.name.toLowerCase();

            if (nameA < nameB) {
                return -1;
            }
            if (nameA > nameB) {
                return 1;
            }
            return 0;
        });
    },
    //   mounted() {},
    mounted() {
        this.startSlideShow();
    },
    beforeUnmount() {
        if (this.slideInterval) {
            clearInterval(this.slideInterval);
        }
    },
    watch: {
        password: {
            handler(newVal, oldVal) {
                this.passwordRequirements.forEach((req) => {
                    if (req.criteria.test(newVal)) {
                        req.color = "color: #1ACF85";
                        req.valid = true;
                    } else {
                        req.color = "color: #FD5542";
                        req.valid = false;
                    }
                });
            },
            deep: true,
        },
        confPassword(newVal, oldVal) {
            if (!newVal.length) {
                this.registerValidation.confirmPassword.color = "";
                this.registerValidation.confirmPassword.msg = "";
                this.registerValidation.confirmPassword.valid = false;
            } else if (newVal !== this.password) {
                this.registerValidation.confirmPassword.color = "color: #FD5542";
                this.registerValidation.confirmPassword.msg = "Passwords does not match";
                this.registerValidation.confirmPassword.valid = false;
            } else {
                this.registerValidation.confirmPassword.color = "color: #1ACF85";
                this.registerValidation.confirmPassword.msg = "Passwords matched";
                this.registerValidation.confirmPassword.valid = true;
            }
        },
    },
    methods: {
        ...mapActions("DemoStore", [
            "setselectedLanguage",
            "initializeTranslation",
        ]),
        startSlideShow() {
            if (this.slideInterval) {
                clearInterval(this.slideInterval);
            }
            this.slideInterval = setInterval(() => {
                this.nextSlide();
            }, 3000);
        },
        nextSlide() {
            this.currentSlide = (this.currentSlide + 1) % this.slides.length;
        },
        goToSlide(index) {
            if (index === this.currentSlide) return;
            this.currentSlide = index;
            this.startSlideShow();
        },
        handleSubmitButton(){
            if(this.isEmailSent){
                this.$router.push({name: 'login'})
            }
            else{
                this.checkEmail();
            }
        },
        checkEmail() {
            const url = "/api/sense_user/recovery/";
            const payload = {
                'email_id': this.email.trim(),
            }
            if (!this.email) {
                this.$bvToast.toast(`Please enter your email.`, {
                    title: "Weavr Sense",
                    variant: "danger",
                    toaster: "b-toaster-top-right",
                    autoHideDelay: 3000,
                });
                return;
            }
            else{
                if(!this.validEmail(this.email)){
                    this.$bvToast.toast(`Please enter a valid email (${this.email})`, {
                        title: "Weavr Sense",
                        variant: "danger",
                        toaster: "b-toaster-top-right",
                        autoHideDelay: 3000,
                    });
                    return false;
                }
            }
            this.loader = true;
            this.$http.post(url, payload).then((response) => {
                    this.isEmailSent = true

                    this.loader = false;
                }).catch((err) => {
                    this.loader = false;
                    this.$bvToast.toast(`${err.body.summary}`, {
                        title: "Weavr Sense",
                        variant: "danger",
                        toaster: "b-toaster-top-right",
                        autoHideDelay: 3000,
                    });
                });
        },
        validEmail(email) {
            var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return re.test(email);
        },
    },
   

};
</script>
<style scoped>
input:-webkit-autofill,
input:-webkit-autofill:hover,
input:-webkit-autofill:focus,
input:-webkit-autofill:active {
    -webkit-box-shadow: 0 0 0 30px white inset !important;
    -webkit-text-fill-color: #000 !important;
    transition: background-color 5000s ease-in-out 0s;
}

#registerPage {
    font-family: "Poppins", sans-serif;
    background-color: white;
}

.login-page-slider {
    position: relative;
    width: 100%;
    height: 87vh;
    overflow: hidden;
    /* background-color: #0655590D !important;
    background: url('../../../public/Icons_SVG/bgImgLogin.svg') no-repeat right center; */
}

.showhidePassword {
    position: absolute;
    top: 35%;
    right: 3%;
    color: #c3c3c3;
    cursor: pointer;
}

.form-container label {
    font-size: 14px;
    font-weight: 400;
    font-family: 'Poppins';
    color: #505050;
}

.mainHeading {
    color: #000;
    font-family: 'Poppins';
    font-weight: 600 !important;
    font-size: 28px;
    line-height: 36px;
    letter-spacing: 0%;
}

.subHeading {
    font-size: 16px;
    color: #050A13;
    font-weight: 400;
    font-family: 'Poppins';
    margin-bottom: 24px !important;
    margin-top: 16px !important;
}

.redirect {
    color: #050A13;
    font-family: Poppins;
    font-weight: 400;
    font-size: 16px;
}

.redirect span {
    color: var(--primary_brand) !important;
    cursor: pointer !important;
    font-family: Poppins;
    font-weight: 600;
    font-size: 16px;
}

.weavrLogoContainer {
    padding: 0 1rem;
    /* margin-left: 0.5rem; */
}

/* .weavrLogoContainer img {
  height: 45px;
} */

.container-fluid {
    height: 100vh !important;
    padding: 0 !important;
    /* gap: 10rem; */
}

.hero-login-section {
    width: 100%;
    height: 100% !important;
}

.left-img {
    padding: 0 !important;
    width: 44%;
}

.login-page-img img {
    height: 89vh !important;
    width: 100%;
    padding-bottom: 10px;
}

.form-container {
    width: 70%;
    margin: 0 auto;
    /* padding-top: 40px; */
}

.negative-margin {
    margin-bottom: -10px !important;
}

.gap {
    gap: 5%;
}

.dropdown-group {
    display: flex;
    flex-direction: column;
}

.dropdown-group>div:first-child {
    width: 60%;
}

#dropdown {
    position: relative;
    padding: 9.5px 16px;
    border-radius: 5PX;
    border: 1px solid #AEAEAE;
    cursor: pointer;
    /* margin-top: 10px; */
}

#dropdown label {
    position: absolute;
    color: var(--primary_brand);
    background-color: white;
    top: -14px;
    left: 20px;
    font-size: 16px;
    padding-inline: 4px;
}

#dropdown i {
    font-size: 18px !important;
    margin-block: -4px !important;
    color: #5e5e5e;
    max-height: 43px;
    text-overflow: ellipsis;
}

#country-search {
    height: 35px;
    border: 1px solid var(--primary_brand-80);
    border-right: none;
    border-radius: 8px;
    display: flex;
    justify-content: space-between;
    align-items: center;
}

#country-search input {
    border: none;
    width: 90%;
    padding-inline: 16px;
}

#country-search input:focus {
    box-shadow: none !important;
    outline: none !important;
    border: none;
}

#country-search input:-webkit-autofill {
    -webkit-box-shadow: 0 0 0 1000px #fff inset !important;
    font-family: "Poppins", sans-serif !important;
}

#country-search input:-moz-autofill {
    box-shadow: 0 0 0 1000px #fff inset !important;
    font-family: "Poppins", sans-serif !important;
}

#country-search span {
    color: white;
    background-color: var(--primary_brand);
    height: 100%;
    width: 10%;
    display: flex;
    justify-content: center;
    align-items: center;
    border-top-right-radius: 7px;
    border-bottom-right-radius: 7px;
}

#country-dropdown {
    position: absolute;
    background-color: white;
    border-radius: 7px;
    max-height: 150px;
    overflow-y: auto;
    border: 1px solid #d9d9d9;
    padding-block: 10px;
    margin-top: 10px;
    width: 50%;
}

.country-list {
    display: flex;
    gap: 8px;
    align-items: center;
    padding: 7px 24px;
    cursor: pointer;
    border-bottom: 1px solid #d9d9d9;
}

.dial-code {
    border: 0.5px solid #afafaf;
    color: #afafaf;
    font-size: 12px;
    border-radius: 20px;
    padding: 4px 14px;
}

.phone-code span {
    position: absolute;
    left: 3%;
    top: 18%;
    height: 65%;
    display: flex;
    align-items: center;
}

#phoneNumber {
    padding-left: 3.5rem !important;
}

.country-list:hover {
    background-color: var(--primary_brand-10);
    color: var(--primary_brand-80);
}

.country-list.active {
    background-color: var(--primary_brand);
    color: white;
}

.country-list.active>.dial-code {
    color: white;
    border-color: white;
}

.input-group {
    position: relative;
    margin-bottom: 1.3rem;
    flex-direction: column !important;
}

/* .input-group label {
  position: absolute;
  color: var(--primary_brand);
  background-color: white;
  top: -2px;
  left: 20px;
  font-size: 16px;
  padding-inline: 4px;
} */
.input-group input {
    padding: 10px 12px 10px 40px;
    border: 1px solid #AEAEAE;
    width: 100%;
    height: 100%;
    background: #fff !important;
    outline: none !important;
    border-radius: 5px;
    box-shadow: none !important;
}

.input-group input:focus {
    box-shadow: none !important;
    outline: none !important;
    border: 1.5px solid var(--primary_brand) !important;
}

.input-group input:-webkit-autofill {
    -webkit-box-shadow: 0 0 0 1000px #fff inset !important;
    font-family: "Poppins", sans-serif !important;
}

.input-group input:-moz-autofill {
    box-shadow: 0 0 0 1000px #fff inset !important;
    font-family: "Poppins", sans-serif !important;
}

.error-flag {
    font-size: 12px;
    margin: 0;
    padding-top: 2px;
    padding-left: 6px;
    margin-top: 4px;
}

.error-flag .valid {
    color: green;
}

.error-flag .invalid {
    color: red;
}

.error-flag .invalid i {
    padding: 2px 3px;
    border: 1px solid red;
    border-radius: 50%;
}

.error-flag .valid i {
    padding: 2px 3px;
    border: 1px solid green;
    border-radius: 50%;
}

.country-flag img {
    width: 30px;
    height: 20px;
    /* border-radius: 50%; */
    object-fit: cover;
}

button.primarycolor {
    background: var(--primary_brand);
    font-family: "Poppins", sans-serif;
    color: white;
    padding: 12px 25px;
    border-radius: 6px;
    letter-spacing: 0.2px;
    font-weight: bold;
    font-size: 16px;
    border: none;
}

button.primarycolor:hover {
    color: white;
    background: var(--primary_brand-80);
    /* border: 1.6px solid var(--base_color); */
}

.validity-req-list {
    font-size: 12px;
    color: #919191;
}

.validity-req-list i {
    color: #e8e8e8;
}

/* slider css */
.slider-container {
    position: relative;
    width: 100%;
    height: 100%;
    overflow: hidden;
}

.slide-wrapper {
    position: absolute;
    width: 100%;
    height: 100%;
    opacity: 0;
    transform: translateX(-100%);
    /* Enter from left */
    transition: all 0.5s ease-in-out;
    visibility: hidden;
}

.slide-wrapper.active {
    opacity: 1;
    transform: translateX(0);
    visibility: visible;
}

.slide-wrapper:not(.active) {
    transform: translateX(100%);
    /* Exit to right */
    opacity: 0;
}

/* .slideImgContainer {
    padding: 9rem;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
} */

.slideImgContainer {
    padding-left: 15rem;
    padding-right: 15rem;
    padding-top: 4rem;
    padding-bottom: 40px !important;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
}

.slide-image {
    width: 100%;
    height: 100%;
    /* object-fit: cover; */
}

.slide-content {
    position: absolute;
    top: 0%;
    left: 5%;
    max-width: 70%;
    padding: 2rem;
    z-index: 2;
    text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.3);
}

.slide-content h2 {
    color: var(--primary_brand);
    font-family: Poppins;
    font-weight: 600;
    font-size: 24px;
    line-height: 36px;
    /* letter-spacing: 0%; */
    text-shadow: none !important;
}

.slide-content p {
    font-family: Poppins;
    font-weight: 500;
    font-size: 16px;
    line-height: 24px;
    letter-spacing: 0%;
    color: #000;
    text-shadow: none !important;
}

.slider-controls {
    position: absolute;
    bottom: 20px;
    width: 100%;
    display: flex;
    justify-content: center;
    z-index: 3;
}

.slider-dots {
    display: flex;
    gap: 10px;
}

.dot {
    width: 10px;
    height: 10px;
    border-radius: 50%;
    background: #c4c4c4;
    cursor: pointer;
    transition: all 0.3s ease;
}

.dot.active {
    background: var(--primary_brand);
    transform: scale(1.2);
}

.fullBgImg {
    background-color: #0655590d !important;
    background: url("../../../public/Icons_SVG/bgImgLogin.svg") no-repeat right center;
    height: 100vh;
    position: relative;
}
</style>

<style scoped>
.brand-slider {
    width: 100%;
    padding: 1rem;
}

.brand-logo {
    width: 14rem;
    height: auto;
    object-fit: contain;
}

.brand-slide {
    display: flex;
    justify-content: center;
    align-items: center;
}

:deep(.swiper-container) {
    overflow: hidden;
}

.weavrLogoContainer {
    width: 75%;
    margin: 0 auto;
}

.inputIconContainer {
    padding: 10px 14px 14px 16px;
}

/* .inputIconContainer {
  top: 50%;
  transform: translateY(-50%);
} */

.inputIconContainer img {
    width: 16px !important;
    height: 16px !important;
}

input::placeholder {
    color: #A1A1A1 !important;
    font-size: 14px !important;
    font-family: 'poppins' !important;
}

img.handleArrowPossition {
    transform: rotate(180deg);
    transition: .3s ease-in-out;
}
</style>
